import classNames from "classnames";

import { ReactComponent as Icon_CheckmarkCircle16 } from "./CheckmarkCircle16.svg";
import { ReactComponent as Icon_CheckmarkCircleFilled16 } from "./CheckmarkCircleFilled16.svg";
import { ReactComponent as Icon_CloseCircleFilled16 } from "./CloseCircleFilled16.svg";

import style from "./BulletPoint.module.css";

interface BulletPointProps {
  icon: "checkmark_circle_filled" | "checkmark_circle" | "close_circle_filled";
  text: string;
}

export const BulletPoint: React.FC<BulletPointProps> = ({ icon, text }) => (
  <div>
    <div className={style.container}>
      {icon === "checkmark_circle" && (
        <div className={classNames(style.bullet, style.blue)}>
          <Icon_CheckmarkCircle16 />
        </div>
      )}
      {icon === "checkmark_circle_filled" && (
        <div className={classNames(style.bullet, style.blue)}>
          <Icon_CheckmarkCircleFilled16 />
        </div>
      )}
      {icon === "close_circle_filled" && (
        <div className={classNames(style.bullet, style.gray)}>
          <Icon_CloseCircleFilled16 />
        </div>
      )}
      <p className={classNames(style.text, icon === "close_circle_filled" && style.gray)}>{text}</p>
    </div>
  </div>
);
